import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-154545df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "links" }, [
  /*#__PURE__*/_createTextVNode(" Al continuar, aceptas la "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://getindya.com/aviso-legal/",
    target: "_blank"
  }, " política de privacidad "),
  /*#__PURE__*/_createTextVNode(" y "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://getindya.com/proteccion-de-datos-gdpr/",
    target: "_blank"
  }, " protección de datos "),
  /*#__PURE__*/_createTextVNode(" de INDYA. ")
], -1))
const _hoisted_4 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailInput = _resolveComponent("EmailInput")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_EmailInput, {
        message: "¿Olvidaste tu email?",
        onMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('forgotEmail'))),
        modelValue: _ctx.form.email,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
        placeholder: "Email",
        onEnter: _ctx.throwEvent
      }, null, 8, ["modelValue", "onEnter"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_PasswordInput, {
        message: "¿Olvidaste tu contraseña?",
        onMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('forgotPassword'))),
        modelValue: _ctx.form.password,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password) = $event)),
        onEnter: _ctx.throwEvent,
        placeholder: "Contraseña"
      }, null, 8, ["modelValue", "onEnter"])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        onClick: _ctx.throwEvent,
        disabled: !_ctx.formValidated,
        variant: "turquoise"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Continuar ")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}